import { Routes } from '@/routes';

export default {
	'audit.index': () => import('@/modules/audit/index'),
} as Routes;
